BoardListSectionComponent = require './board-list-section-component'
ReactDnd = require 'react-dnd'
React = require 'react'

_BoardListSectionDndComponent = class extends React.Component
  displayName: 'BoardListSectionDndComponent'
  render: ->
    { connectDropTarget } = @props
    connectDropTarget(React.createElement('div', {}, React.createElement(BoardListSectionComponent, @props)))

spec =
  drop: ->

collect = (connect, monitor) ->
  connectDropTarget: connect.dropTarget()

module.exports = ReactDnd.DropTarget('BoardTile', spec, collect)(_BoardListSectionDndComponent)
